const SHOW_LINKS = process.env.REACT_APP_HOME_VERSION as string === '1'

export default function useCircularNavigation() {
  return SHOW_LINKS
}
